module.exports = __webpack_public_path__ + "img/vape-shop-custom-website.bd7c66a2.jpeg";